import React from "react";

type Tone = "green" | "amber" | "blue";

const toneMap: Record<Tone, { chipBg: string; chipRing: string; chipText: string }> = {
    green: { chipBg: "bg-emerald-200", chipRing: "ring-emerald-300", chipText: "text-emerald-900" },
    amber: { chipBg: "bg-amber-200", chipRing: "ring-amber-300", chipText: "text-amber-900" },
    blue: { chipBg: "bg-sky-200", chipRing: "ring-sky-300", chipText: "text-sky-900" },
};

export default function StatsCard({
    label,
    value,
    deltaPct,
    icon = "task_alt",
    tone = "green",
    className = "",
}: {
    label: string;
    value: number | string;
    deltaPct?: number;
    icon?: string;
    tone?: Tone;
    className?: string;
}) {
    const positive = (deltaPct ?? 0) >= 0;
    const fmt = deltaPct == null ? "" : `${positive ? "+" : ""}${deltaPct.toFixed(1)}%`;

    return (
        <div
            className={[
                // Card shell
                "rounded-2xl overflow-hidden border border-[#777B7F]/50",
                "bg-white",
                className,
            ].join(" ")}
        >
            {/* Top dark slab */}
            <div className="relative bg-[#1B1D1F] text-white h-[104px] px-4 pt-3 pb-4 rounded-2xl">
                <div className="text-[14px] text-white/75">{label}</div>
                <div className="mt-1 text-[28px] font-semibold ">{value}</div>

                {/* Icon chip (top-right) */}
                <div
                    className={[
                        "absolute right-4 top-3 h-8 w-8 rounded-full grid place-items-center",
                        "ring-1",
                        toneMap[tone].chipBg,
                        toneMap[tone].chipRing,
                        toneMap[tone].chipText,
                    ].join(" ")}
                >
                    <span className="material-icons text-[18px]">{icon}</span>
                </div>
            </div>

            {/* Bottom light strip */}
            <div className="h-[48px] px-4 flex items-center justify-between">
                <span className="text-[12px] text-[#777B7F]">From last month</span>

                {deltaPct != null && (
                    <div
                        className={[
                            "flex items-center gap-1 text-[12px] font-medium",
                            positive ? "text-[#16A34A]" : "text-[#DC2626]",
                        ].join(" ")}
                    >
                        <span className="material-icons text-[16px]">
                            {positive ? "trending_up" : "trending_down"}
                        </span>
                        {fmt}
                    </div>
                )}
            </div>
        </div>
    );
}
